import React, { Component } from "react";
import Lightbox from "react-image-lightbox";
import Image from "../../base/features/micro/Image";
import { apiService } from "../../base/utils/service";
import Spinner from "../../base/features/micro/Spinner";
import SimpleHeader from "../../base/features/blocks/SimpleHeader";

class UserCustomProductsDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      product: null,
      productId: window.location.pathname.split("/")[2],
      selectedImage: null,
    };
  }
  componentDidMount() {
    this.getProduct();
  }
  getProduct() {
    apiService(
      `v1/personalized-product-requests/${this.state.productId}`,
      "get"
    ).then((data) => {
      if (data) {
        this.setState({
          product: data,
        });
      }
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <SimpleHeader text="محصول سفارشی" />
        {this.state.product ? (
          <div className="row mx-0" style={{ marginTop: "80px" }}>
            <div className="row mx-0 px-0">
              <div className="col-auto px-1 align-self-center">
                <Image
                  imageUri={
                    this.state.product.shop.cover &&
                    this.state.product.shop.cover.thumbnail
                  }
                  imageHeight={"90"}
                  imageWidth={"90"}
                  imgClassName={"rounded14 img-cover"}
                  extraClassName={"rounded-circle p-2 bg-color-main"}
                />
              </div>
              <div className="col px-1 align-self-center">
                <p className="fw-bolder mb-0 fs-6">
                  {this.state.product.shop && this.state.product.shop.title}
                  {this.state.product.shop &&
                    this.state.product.shop.is_verify && (
                      <img
                        width="15"
                        className="me-1"
                        alt="verify"
                        src={
                          require("../../base/assets/icons/verify.svg").default
                        }
                      />
                    )}
                </p>
                <p className="fw-bolder mb-0 fs-7 text-muted">
                  {this.state.product.created}
                </p>
              </div>
              <div className="col-auto px-1">
                <p className="mb-0 small fw-bold bg-warning px-2 py-1 rounded-3 text-white">
                  {this.state.product.status === 1
                    ? "ثبت شده"
                    : this.state.product.status === 0
                    ? "در حال آماده سازی"
                    : "موافقت نشده"}
                </p>
              </div>
            </div>
            <div className="row mx-0 px-0 mt-3">
              <div className="col-12 px-0 mb-3">
                <h2 className="fs-6 fw-bold">توضیحات</h2>
                <p className="small">{this.state.product.des}</p>
              </div>
              <div className="col-12 px-0">
                <h2 className="fs-6 fw-bold">تصاویر</h2>
                {this.state.product.medias.map((media, m) => (
                  <div
                    className="d-inline-block ms-2"
                    onClick={() => this.setState({ selectedImage: media })}
                  >
                    <Image
                      imageUri={media.thumbnail}
                      imageHeight={"60"}
                      imageWidth={"60"}
                      imgClassName={"rounded7 img-cover"}
                      extraClassName={"rounded-circle p-2 bg-color-main"}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <Spinner />
        )}
        {this.state.selectedImage && (
          <Lightbox
            mainSrc={this.state.selectedImage.file}
            onCloseRequest={() => this.setState({ selectedImage: null })}
            reactModalStyle={{
              overlay: {
                zIndex: "100000000",
              },
              content: {
                zIndex: "100000000",
              },
            }}
          />
        )}
      </div>
    );
  }
}

export default UserCustomProductsDetail;
